import FooterNavColumn from './FooterNavColumn'

export default FooterNavColumn
